module.exports = __webpack_public_path__ + "img/home_city_icon3_disabled.634ed5c.png";